export default {"src":"/_next/static/media/comments_filled.280dea5b.svg","height":24,"width":24};